// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c884682c","455":"e48b1a57"}[chunkId] + ".chunk.js";
};